import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { Card, Input } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import DateFnsUtils from '@date-io/date-fns';
import fakeData from '../../fakeData'
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { Link, useParams } from 'react-router-dom';




const Booking = () => {
    const { id } = useParams();
    console.log(id)
    const [selectedDate, setSelectedDate] = useState({
        CheekIn: new Date(),
        CheckOut: new Date()
    })
    const handleCheckInDate = (date) => {

        const newDatesIn = { ...selectedDate.CheekIn }
        newDatesIn.CheekIn = date
        setSelectedDate(newDatesIn)
    };

    const handleCheckOutDate = (date) => {
        const newDatesOut = { ...selectedDate }
        newDatesOut.CheekOut = date
        setSelectedDate(newDatesOut)
    };


    const [paramsInfo, setparamsInfo] = useState({
        Destination: '', Description: '', Origin: ''
    });
    
  
    useEffect(() => {
        const InfoData = fakeData.find(pd => pd.id.toString() === id);
        const destination = InfoData.name;
        const description = InfoData.description;
        const ParamsData = { Destination: destination, Description: description }

        setparamsInfo(ParamsData)
    }, [id])
 
    return (
        <div className="container">
            <div className="row">
                <Card className="col-md-6" >
                 
                        <h1>{paramsInfo.Destination}</h1>
                        <p>{paramsInfo.Description}...</p>
                   
                </Card>
                <Card className="col-md-4 ms-3 mt-3 p-4">
                  
                        <form   >
                            <input
                             type="name"
                               required
                                className="w-100 "
                                placeholder="From"
                                />
                             <br/>
                             <br/>
                            <input
                                id="standard-full-width"
                                className="w-100"
                                value={paramsInfo.Destination}
                                />
                               <br/>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                               
                                    <KeyboardDatePicker
                                        disableToolbar
                                        variant="inline"
                                        format="MM/dd/yyyy"
                                        margin="normal"
                                        id="date-picker-inline"
                                        label="Date picker inline"
                                        value={selectedDate.CheekIn}
                                        onChange={handleCheckInDate}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        className="w-100"
                                    />
                                      <br/>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="date-picker-dialog"
                                        label="Date picker dialog"
                                        format="MM/dd/yyyy"
                                        value={selectedDate.CheekOut}
                                        onChange={handleCheckOutDate}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date', }}
                                            className="w-100"
                                             />                                     
           
                            </MuiPickersUtilsProvider>
                            <br/>
                                    <Link  to={`/bookingDetails/${id}`} >                                
                                        <Button type="submit" className="w-100" variant="contained" value="submit" color="primary" >
                                           Submit
                                        </Button>
                                    </Link>
                        </form>
                  
                </Card>
            </div>

        </div>
    );
};

export default Booking;